import head from 'lodash/head';
import { TypeA2 } from '@yme/assets/icons/license-types';
import { NA_VALUE } from '@yme/common/constants';
import { STATUS_INIT, STATUS_RELOAD } from './constants';
export function getColorIndex(colorVariants, currSku) {
    const isDataExist = colorVariants !== undefined && currSku;
    const colorIndex = isDataExist
        ? colorVariants?.findIndex((item) => item.skuList.some((itemSku) => itemSku.toLowerCase() === currSku?.toLowerCase()))
        : 0;
    return colorIndex;
}
export const getAvailableSkuByValue = ({ colorVariants, }) => {
    let newVariant = colorVariants?.find((item) => item.stock > 0 && item.prices.amount > 0);
    newVariant =
        newVariant || colorVariants?.find((item) => item.prices.amount > 0);
    newVariant = newVariant || colorVariants?.find((item) => item);
    return newVariant;
};
// Helper for hook for define filter options: for Default Filter
export function prepareDefaultFilterOptions({ colorVariants, index, sku = '', statusType, }) {
    const commonProps = {
        colorItemIndex: index,
        colourId: colorVariants[index]?.colourId,
        productType: colorVariants[index]?.productType,
    };
    const variantsOfProduct = colorVariants[index]?.variantsOfProduct || [];
    if (variantsOfProduct.length) {
        let activeVariant;
        if (statusType === STATUS_INIT) {
            activeVariant =
                activeVariant || variantsOfProduct.find((item) => item.master);
            activeVariant =
                activeVariant ||
                    variantsOfProduct.find((item) => [item.stock > 0, item.prices.amount > 0].every((i) => i));
            activeVariant =
                activeVariant ||
                    variantsOfProduct.find((item) => [item.prices.amount > 0].every((i) => i));
        }
        if (statusType === STATUS_RELOAD) {
            activeVariant = variantsOfProduct.find((item) => item.sku === sku);
        }
        activeVariant =
            activeVariant ||
                variantsOfProduct.find((item) => item.stock > 0 && item.prices.amount > 0);
        activeVariant =
            activeVariant || variantsOfProduct.find((item) => item.prices.amount > 0);
        activeVariant =
            activeVariant || variantsOfProduct.find((item) => Boolean(item));
        return {
            ...commonProps,
            sku: activeVariant?.sku || '',
        };
    }
    return {
        ...commonProps,
        sku: '',
    };
}
export function getAvailableSkuBySizeValue({ colorVariants, sizeValue, }) {
    let activeVariant = colorVariants?.find((item) => item.size === sizeValue && item.stock > 0);
    // case if previous condition return 'undefined' for 'activeVariant'
    if (!activeVariant) {
        activeVariant = colorVariants?.find((item) => item.size === sizeValue);
    }
    // case if previous condition return 'undefined' for 'activeVariant'
    if (!activeVariant) {
        activeVariant = colorVariants?.find((item) => item.size);
    }
    return activeVariant;
}
export function buildRadioButtonsOptionsList(options) {
    const res = options.reduce((acc, itemValue) => {
        if (itemValue !== NA_VALUE) {
            const itemOptions = {
                value: itemValue,
            };
            return [...acc, itemOptions];
        }
        return acc;
    }, []);
    return res;
}
export function getMotoScootersValues(listOptions, power35kwLocaleName = '') {
    return listOptions?.reduce((acc, item) => {
        const newItem = {
            key: item,
            value: item,
            iconType: power35kwLocaleName === item ? TypeA2 : undefined,
        };
        return !acc ? [newItem] : [...acc, newItem];
    }, []);
}
export const getSortedProductVariationsValues = (versions, secondVariant = '') => {
    if (head(versions)?.value !== secondVariant) {
        return versions;
    }
    return versions.reverse();
};
